import { render, staticRenderFns } from "./Semiconductor.vue?vue&type=template&id=2c192ce4&scoped=true"
import script from "./Semiconductor.vue?vue&type=script&lang=js"
export * from "./Semiconductor.vue?vue&type=script&lang=js"
import style0 from "./Semiconductor.vue?vue&type=style&index=0&id=2c192ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c192ce4",
  null
  
)

export default component.exports